import { render } from "./SiteNavigation.vue?vue&type=template&id=8f0d814e&scoped=true"
const script = {}

import "./SiteNavigation.vue?vue&type=style&index=0&id=8f0d814e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0d814e"]])

export default __exports__